// Deal pipeline configuration — single source of truth on the frontend
export const STAGES = [
  { key: "icpo_submitted",     label: "ICPO Submitted",     short: "ICPO" },
  { key: "soft_probe",         label: "Soft Probe",         short: "Probe" },
  { key: "fco_received",       label: "FCO Received",       short: "FCO" },
  { key: "ncnda_signed",       label: "NCNDA Signed",       short: "NCNDA" },
  { key: "imfpa_lodged",       label: "IMFPA Lodged",       short: "IMFPA" },
  { key: "spa_executed",       label: "SPA Executed",       short: "SPA" },
  { key: "commission_cleared", label: "Commission Cleared", short: "Cleared" },
];

export const stageIndex = (k) => STAGES.findIndex((s) => s.key === k);

export const stageLabel = (k) =>
  STAGES.find((s) => s.key === k)?.label || k;

export const DOC_STATUSES = ["pending", "drafted", "sent", "signed", "lodged", "executed"];
